"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get MAX_SURVEY_ANSWER_LENGTH () {
        return MAX_SURVEY_ANSWER_LENGTH;
    },
    get SurveyAnswerSchema () {
        return SurveyAnswerSchema;
    },
    get SurveyResponseSchema () {
        return SurveyResponseSchema;
    },
    get SurveyResponseValidationSchema () {
        return SurveyResponseValidationSchema;
    }
});
const _bson = require("bson");
const _zod = require("zod");
const _survey = require("./survey");
const MAX_SURVEY_ANSWER_LENGTH = 3000;
const SurveyAnswerValue = _zod.z.union([
    _zod.z.string().max(MAX_SURVEY_ANSWER_LENGTH),
    _zod.z.array(_zod.z.string().length(24)).max(_survey.MAX_NUMBER_QUESTION_OPTIONS)
]).nullable();
const SurveyAnswerSchema = _zod.z.object({
    question_id: _zod.z.instanceof(_bson.ObjectId),
    value: SurveyAnswerValue
});
/**
 * Holds static respondent information captured at response time
 * e.g. _id, cohorts, ip address, etc.
 * Not intended to be synced by changes in other systems.
 */ const IRespondentSchema = _zod.z.object({
    _id: _zod.z.instanceof(_bson.ObjectId)
});
const SurveyResponseSchema = _zod.z.object({
    _id: _zod.z.instanceof(_bson.ObjectId),
    company_id: _zod.z.instanceof(_bson.ObjectId),
    survey_id: _zod.z.instanceof(_bson.ObjectId),
    respondent: IRespondentSchema,
    submitted_at: _zod.z.date(),
    answers: _zod.z.array(SurveyAnswerSchema)
});
const SurveyResponseValidationSchema = SurveyResponseSchema.omit({
    _id: true
});
